export enum AttachmentType {
  Image = 'IMAGE',
  Link = 'LINK'
}

export type Attachment = { name?: string; title?: string; url: string; type: AttachmentType; _pending?: boolean }
